import { Injectable, EventEmitter } from '@angular/core';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/map'

//  Services
import { AmssService } from './amss.service';

@Injectable()
export class ReviewService extends AmssService {
    public UpdateReviewEvent$: EventEmitter<any>;

    constructor() {   
        super();      
        this.UpdateReviewEvent$ = new EventEmitter<any>();
    }

    public getReviewsFromUsername(id: string) {
        return super.getHttpService()
            .GET(this.apiUrl + '/reviewer/getFromUser/' + this.year + '/' + id, true)
            .map(response => response.json());
    }
    public getReviewsForReviewer(id: string) {
        return super.getHttpService()
            .GET(this.apiUrl + '/review/adata/list/' + this.year + '?reviewer=' + id, true)
            .map(response => response.json());
    }

    public getReview(id: string) {
        return super.getHttpService()
            .GET(this.apiUrl + '/review/get/' + this.year + '/' + id, true)
            .map(response => response.json());
    }

    updateReview(id: number, criteria: number, score: number) {
        var data = {
            comment: '',
            criterion: criteria,
            review: id,
            score: score
        };

        var dataString = JSON.stringify(data);

        return super.getHttpService()
            .PUT(this.apiUrl + '/review/score/put/' + this.year, 'json', dataString, true)
            .map(response => response.json());
    }

    public emitReviewerEvent(type, unit) {
        this.UpdateReviewEvent$.emit({ type: type, data: unit });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/review.service.ts